// // Localização: frontend/src/pages/Agendamentos/AgendamentoForm.js (Versão 1.0.0)

// import React, { useState, useEffect } from 'react';
// import api from '../../api/api';
// import { useAuth } from '../../context/AuthContext';

// // Valores fixos baseados na sua tabela SQL
// const TIPOS_AGENDAMENTO = ['Medicamento', 'Tarefa', 'Consulta'];
// const STATUS_AGENDAMENTO = ['Pendente', 'Concluído', 'Cancelado']; // Em Andamento é definido pelo check-in

// const AgendamentoForm = ({ onSubmit, initialData = {} }) => {
//     const { user } = useAuth();
//     const [formData, setFormData] = useState({
//         paciente_id: initialData.paciente_id || '',
//         usuario_id: initialData.usuario_id || (user?.role?.toLowerCase() === 'profissional' ? user.id : ''),
//         tipo: initialData.tipo || TIPOS_AGENDAMENTO[0],
//         descricao: initialData.descricao || '',
//         data_hora_inicio: initialData.data_hora_inicio ? initialData.data_hora_inicio.substring(0, 16) : '',
//         data_hora_fim: initialData.data_hora_fim ? initialData.data_hora_fim.substring(0, 16) : '',
//         status: initialData.status || STATUS_AGENDAMENTO[0],
//         tipo_cuidado: initialData.tipo_cuidado || '',
//     });
//     const [pacientes, setPacientes] = useState([]);
//     const [profissionais, setProfissionais] = useState([]);
//     const [loadingResources, setLoadingResources] = useState(true);
//     const [formError, setFormError] = useState('');

//     // Roles que podem gerenciar (atribuir a outros)
//     const canManage = ['proprietario', 'admin', 'gerente'].includes(user?.role?.toLowerCase());

//     useEffect(() => {
//         const fetchResources = async () => {
//             try {
//                 // Busca Pacientes (Todos os pacientes da organização do usuário logado)
//                 const pacientesRes = await api.get('/pacientes');
//                 setPacientes(pacientesRes.data);

//                 // Busca Profissionais (Todos os usuários com papel de profissional/médico)
//                 // Assumindo que a rota de usuários pode ser filtrada ou retorna todos.
//                 // Aqui, simplificamos buscando todos os usuários da organização (Admin pode filtrar depois)
//                 const profissionaisRes = await api.get('/usuarios?role=profissional'); // Exemplo de filtro
//                 setProfissionais(profissionaisRes.data);

//             } catch (err) {
//                 console.error('Erro ao carregar recursos (Pacientes/Profissionais):', err);
//                 setFormError('Erro ao carregar pacientes e profissionais. Verifique o backend.');
//             } finally {
//                 setLoadingResources(false);
//             }
//         };
//         fetchResources();
//     }, []);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({
//             ...formData,
//             [name]: value,
//         });
//         setFormError('');
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();

//         // Validação básica
//         if (!formData.paciente_id || !formData.data_hora_inicio || !formData.descricao) {
//             return setFormError('Preencha pelo menos o Paciente, Data/Hora de Início e Descrição.');
//         }

//         // Passa os dados limpos para a função de submissão do componente pai (Agendamentos.js)
//         onSubmit(formData);
//     };
    
//     if (loadingResources) {
//         return <p className="text-center text-teal-600">Carregando dados...</p>;
//     }
    
//     return (
//         <form onSubmit={handleSubmit} className="space-y-4">
//             {formError && (
//                 <div className="p-3 text-sm text-red-700 bg-red-100 rounded" role="alert">
//                     {formError}
//                 </div>
//             )}

//             {/* Campo Paciente */}
//             <div>
//                 <label className="block text-sm font-medium text-gray-700">Paciente</label>
//                 <select
//                     name="paciente_id"
//                     value={formData.paciente_id}
//                     onChange={handleChange}
//                     className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
//                     required
//                 >
//                     <option value="">Selecione o Paciente</option>
//                     {pacientes.map(paciente => (
//                         <option key={paciente.id} value={paciente.id}>
//                             {paciente.nome_completo}
//                         </option>
//                     ))}
//                 </select>
//             </div>

//             {/* Campo Profissional (Visível apenas para Gestores, ou definido como usuário logado) */}
//             {canManage && (
//                 <div>
//                     <label className="block text-sm font-medium text-gray-700">Atribuir a Profissional</label>
//                     <select
//                         name="usuario_id"
//                         value={formData.usuario_id}
//                         onChange={handleChange}
//                         className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
//                     >
//                         <option value="">(Nenhum Profissional Atribuído)</option>
//                         {profissionais.map(prof => (
//                             <option key={prof.id} value={prof.id}>
//                                 {prof.nome_completo} ({prof.role})
//                             </option>
//                         ))}
//                     </select>
//                 </div>
//             )}
            
//             {/* Campo Tipo de Agendamento (Enum) */}
//             <div>
//                 <label className="block text-sm font-medium text-gray-700">Tipo</label>
//                 <select
//                     name="tipo"
//                     value={formData.tipo}
//                     onChange={handleChange}
//                     className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
//                     required
//                 >
//                     {TIPOS_AGENDAMENTO.map(tipo => (
//                         <option key={tipo} value={tipo}>{tipo}</option>
//                     ))}
//                 </select>
//             </div>

//             {/* Campo Tipo de Cuidado (string) */}
//             <div>
//                 <label className="block text-sm font-medium text-gray-700">Título/Tipo de Cuidado</label>
//                 <input
//                     type="text"
//                     name="tipo_cuidado"
//                     value={formData.tipo_cuidado}
//                     onChange={handleChange}
//                     className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
//                     placeholder="Ex: Curativo do Pé, Medição de Glicemia"
//                 />
//             </div>

//             {/* Campo Descrição */}
//             <div>
//                 <label className="block text-sm font-medium text-gray-700">Descrição/Instruções</label>
//                 <textarea
//                     name="descricao"
//                     value={formData.descricao}
//                     onChange={handleChange}
//                     rows="3"
//                     className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
//                     required
//                 />
//             </div>
            
//             {/* Data e Hora Início */}
//             <div>
//                 <label className="block text-sm font-medium text-gray-700">Data e Hora de Início</label>
//                 <input
//                     type="datetime-local"
//                     name="data_hora_inicio"
//                     value={formData.data_hora_inicio}
//                     onChange={handleChange}
//                     className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
//                     required
//                 />
//             </div>
            
//             {/* Data e Hora Fim (Opcional) */}
//             <div>
//                 <label className="block text-sm font-medium text-gray-700">Data e Hora de Fim (Opcional)</label>
//                 <input
//                     type="datetime-local"
//                     name="data_hora_fim"
//                     value={formData.data_hora_fim}
//                     onChange={handleChange}
//                     className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
//                 />
//             </div>

//             {/* Status (Permitido alterar apenas no modo de edição) */}
//             {initialData.id && (
//                 <div>
//                     <label className="block text-sm font-medium text-gray-700">Status</label>
//                     <select
//                         name="status"
//                         value={formData.status}
//                         onChange={handleChange}
//                         className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
//                     >
//                         {STATUS_AGENDAMENTO.map(status => (
//                             <option key={status} value={status}>{status}</option>
//                         ))}
//                     </select>
//                 </div>
//             )}

//             <button 
//                 type="submit"
//                 className="w-full bg-teal-600 hover:bg-teal-700 text-white font-bold py-2 px-4 rounded-md shadow"
//             >
//                 {initialData.id ? 'Atualizar Agendamento' : 'Criar Agendamento'}
//             </button>
//         </form>
//     );
// };

// export default AgendamentoForm;

// Localização: frontend/src/pages/Agendamentos/AgendamentoForm.js (Versão 2.0.0 modificação forma cads)


import React, { useState, useEffect } from 'react';
import { User, Calendar, Clock, FileText, Tag, CheckCircle, ChevronDown, Stethoscope, Home, Briefcase, UserPlus, UserX, UserCircle, Syringe } from 'lucide-react';
import api from '../../api/api';
import { useAuth } from '../../context/AuthContext';
// Componentes UI
import PrimaryButton from '../../components/Common/PrimaryButton';
import DropdownMenu from '../../components/UI/DropdownMenu';
// Utilitários
import { getPacienteFotoUrl, getUsuarioFotoUrl } from '../../utils/imageUtils';

// Valores fixos baseados na sua tabela SQL com ícones do Lucide
const TIPOS_AGENDAMENTO = [
    { value: 'Plantão', label: 'Plantão', icon: Briefcase },
    { value: 'Consulta', label: 'Consulta', icon: Stethoscope },
    { value: 'Visita', label: 'Visita', icon: Home },
    { value: 'Procedimento', label: 'Procedimento', icon: Syringe },
];

const STATUS_AGENDAMENTO = [
    { value: 'Pendente', label: 'Pendente', icon: Clock },
    { value: 'Concluído', label: 'Concluído', icon: CheckCircle },
    { value: 'Cancelado', label: 'Cancelado', icon: FileText },
]; 

const AgendamentoForm = ({ onSubmit, initialData = {} }) => {
    const { user } = useAuth();
    const [formData, setFormData] = useState({
        paciente_id: initialData.paciente_id || '',
        usuario_id: initialData.usuario_id || (user?.role?.toLowerCase() === 'profissional' ? user.id : ''),
        tipo: initialData.tipo || TIPOS_AGENDAMENTO[0].value,
        descricao: initialData.descricao || '',
        data_hora_inicio: initialData.data_hora_inicio ? initialData.data_hora_inicio.substring(0, 16) : '',
        data_hora_fim: initialData.data_hora_fim ? initialData.data_hora_fim.substring(0, 16) : '',
        status: initialData.status || STATUS_AGENDAMENTO[0].value,
        tipo_cuidado: initialData.tipo_cuidado || '',
    });
    const [pacientes, setPacientes] = useState([]);
    const [profissionais, setProfissionais] = useState([]);
    const [loadingResources, setLoadingResources] = useState(true);
    const [formError, setFormError] = useState('');

    const canManage = ['proprietario', 'admin', 'gerente'].includes(user?.role?.toLowerCase());

    // ... (useEffect e Handlers handleChange, handleSubmit, fetchResources permanecem iguais)
    
    // OBS: O código dos Handlers (handleChange, handleSubmit, fetchResources) e useEffect
    // foi omitido para brevidade, mas deve permanecer no seu arquivo.
    
    // Simulação do fetchResources para manter a estrutura, certifique-se de que a sua lógica real esteja aqui.
    useEffect(() => {
        const fetchResources = async () => {
             // Simulação de carregamento de recursos
             setLoadingResources(true);
             try {
                 // **Mantenha sua lógica real de API aqui**
                 const pacientesRes = await api.get('/pacientes');
                 setPacientes(pacientesRes.data);

                 const profissionaisRes = await api.get('/usuarios?role=profissional'); 
                 setProfissionais(profissionaisRes.data);
             } catch (err) {
                 console.error('Erro ao carregar recursos:', err);
                 setFormError('Erro ao carregar pacientes e profissionais.');
             } finally {
                 setLoadingResources(false);
             }
        };
        fetchResources();
    }, []);

    const handleChange = (e) => {
         const { name, value } = e.target;
         setFormData({
             ...formData,
             [name]: value,
         });
         setFormError('');
     };

    // Handler para campos que usam DropdownMenu
    const handleDropdownChange = (name, value) => {
        setFormData({
            ...formData,
            [name]: value,
        });
        setFormError('');
    };

     const handleSubmit = (e) => {
         e.preventDefault();
         if (!formData.paciente_id || !formData.data_hora_inicio || !formData.descricao) {
             return setFormError('Preencha pelo menos o Paciente, Data/Hora de Início e Descrição.');
         }
         onSubmit(formData);
     };

    if (loadingResources) {
        return <p className="text-center text-emerald-600">Carregando dados...</p>;
    }
    
    return (
        <form onSubmit={handleSubmit} className="space-y-5">
            {formError && (
                <div className="p-3 text-sm text-red-700 bg-red-100 rounded" role="alert">
                    {formError}
                </div>
            )}

            {/* Campo Paciente - Usando DropdownMenu */}
            <div>
                <label className="block text-gray-600 font-medium mb-1 flex items-center gap-2">
                    <User size={16} className="text-gray-500" />
                    Paciente
                </label>
                <DropdownMenu
                    trigger={
                        <button
                            type="button"
                            onClick={(e) => e.preventDefault()}
                            className="w-full flex items-center justify-between gap-2 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 hover:bg-gray-50 transition"
                        >
                            <div className="flex items-center gap-2">
                                {(() => {
                                    const pacienteSelecionado = pacientes?.find(p => String(p.id) === String(formData.paciente_id));
                                    
                                    if (!pacienteSelecionado) {
                                        return (
                                            <>
                                                <UserPlus size={20} className="text-gray-400" />
                                                <span className="text-gray-700">
                                                    {loadingResources ? 'Carregando...' : 'Selecione o paciente'}
                                                </span>
                                            </>
                                        );
                                    }
                                    
                                    const temFoto = pacienteSelecionado?.fotoURL;
                                    const fotoUrl = temFoto ? getPacienteFotoUrl(pacienteSelecionado.fotoURL) : null;
                                    
                                    return (
                                        <>
                                            {temFoto && fotoUrl ? (
                                                <img
                                                    src={fotoUrl}
                                                    alt={pacienteSelecionado.nome_completo}
                                                    className="h-6 w-6 rounded-full object-cover border border-gray-200 flex-shrink-0"
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                        const iconElement = e.target.parentElement.querySelector('.fallback-icon');
                                                        if (iconElement) iconElement.style.display = 'block';
                                                    }}
                                                />
                                            ) : null}
                                            <UserCircle 
                                                size={20} 
                                                className="text-gray-400 fallback-icon" 
                                                style={{ display: (temFoto && fotoUrl) ? 'none' : 'block' }} 
                                            />
                                            <span className="text-gray-700">
                                                {pacienteSelecionado.nome_completo}
                                            </span>
                                        </>
                                    );
                                })()}
                            </div>
                            <ChevronDown size={16} className="text-gray-400" />
                        </button>
                    }
                    items={loadingResources ? 
                        [{ id: 'loading', label: 'Carregando...', disabled: true }] :
                        pacientes?.map((p) => {
                            const temFoto = p.fotoURL;
                            const fotoUrl = temFoto ? getPacienteFotoUrl(p.fotoURL) : null;
                            return {
                                id: String(p.id),
                                label: p.nome_completo,
                                ...(temFoto && fotoUrl ? { image: fotoUrl, imageAlt: p.nome_completo } : { icon: UserCircle, iconColor: 'text-gray-400' }),
                                onClick: () => handleDropdownChange('paciente_id', String(p.id))
                            };
                        }) || []
                    }
                    position="bottom-left"
                    className="w-full"
                />
            </div>

            {/* Campo Profissional (Visível apenas para Gestores) - Usando DropdownMenu */}
            {canManage && (
                <div>
                    <label className="block text-gray-600 font-medium mb-1 flex items-center gap-2">
                        <User size={16} className="text-gray-500" />
                        Atribuir a Profissional
                    </label>
                    <DropdownMenu
                        trigger={
                            <button
                                type="button"
                                onClick={(e) => e.preventDefault()}
                                className="w-full flex items-center justify-between gap-2 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 hover:bg-gray-50 transition"
                            >
                                <div className="flex items-center gap-2">
                                    {(() => {
                                        const profissionalSelecionado = profissionais?.find(p => String(p.id) === String(formData.usuario_id));
                                        
                                        if (!profissionalSelecionado) {
                                            return (
                                                <>
                                                    <UserX size={20} className="text-gray-400" />
                                                    <span className="text-gray-700">
                                                        (Nenhum Profissional Atribuído)
                                                    </span>
                                                </>
                                            );
                                        }
                                        
                                        const temFoto = profissionalSelecionado.fotoURL;
                                        const fotoUrl = temFoto ? getUsuarioFotoUrl(profissionalSelecionado.fotoURL) : null;
                                        
                                        return (
                                            <>
                                                {temFoto && fotoUrl ? (
                                                    <img
                                                        src={fotoUrl}
                                                        alt={profissionalSelecionado.nome_completo}
                                                        className="h-6 w-6 rounded-full object-cover border border-gray-200 flex-shrink-0"
                                                        onError={(e) => {
                                                            e.target.style.display = 'none';
                                                            const iconElement = e.target.parentElement.querySelector('.fallback-icon');
                                                            if (iconElement) iconElement.style.display = 'block';
                                                        }}
                                                    />
                                                ) : null}
                                                <UserCircle 
                                                    size={20} 
                                                    className="text-gray-400 fallback-icon" 
                                                    style={{ display: (temFoto && fotoUrl) ? 'none' : 'block' }} 
                                                />
                                                <span className="text-gray-700">
                                                    {profissionalSelecionado.nome_completo} ({profissionalSelecionado.role})
                                                </span>
                                            </>
                                        );
                                    })()}
                                </div>
                                <ChevronDown size={16} className="text-gray-400" />
                            </button>
                        }
                        items={[
                            { 
                                id: 'none', 
                                label: '(Nenhum Profissional Atribuído)', 
                                icon: UserX,
                                iconColor: 'text-gray-400',
                                onClick: () => handleDropdownChange('usuario_id', '')
                            },
                            ...(profissionais?.map((prof) => {
                                const temFoto = prof.fotoURL;
                                const fotoUrl = temFoto ? getUsuarioFotoUrl(prof.fotoURL) : null;
                                return {
                                    id: String(prof.id),
                                    label: `${prof.nome_completo} (${prof.role})`,
                                    ...(temFoto && fotoUrl ? { image: fotoUrl, imageAlt: prof.nome_completo } : { icon: UserCircle, iconColor: 'text-gray-400' }),
                                    onClick: () => handleDropdownChange('usuario_id', String(prof.id))
                                };
                            }) || [])
                        ]}
                        position="bottom-left"
                        className="w-full"
                    />
                </div>
            )}
            
            {/* Campo Tipo de Agendamento - Usando DropdownMenu */}
            <div>
                <label className="block text-gray-600 font-medium mb-1 flex items-center gap-2">
                    <Calendar size={16} className="text-gray-500" />
                    Tipo de Agendamento
                </label>
                <DropdownMenu
                    trigger={
                        <button
                            type="button"
                            onClick={(e) => e.preventDefault()}
                            className="w-full flex items-center justify-between gap-2 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 hover:bg-gray-50 transition"
                        >
                            <div className="flex items-center gap-2">
                                {(() => {
                                    const tipoSelecionado = TIPOS_AGENDAMENTO.find(t => t.value === formData.tipo);
                                    const Icon = tipoSelecionado?.icon || Calendar;
                                    return (
                                        <>
                                            <Icon size={16} className="text-gray-500" />
                                            <span className="text-gray-700">
                                                {tipoSelecionado?.label || "Selecione o tipo"}
                                            </span>
                                        </>
                                    );
                                })()}
                            </div>
                            <ChevronDown size={16} className="text-gray-400" />
                        </button>
                    }
                    items={TIPOS_AGENDAMENTO.map(t => ({
                        id: t.value,
                        label: t.label,
                        icon: t.icon,
                        iconColor: 'text-gray-600',
                        onClick: () => handleDropdownChange('tipo', t.value)
                    }))}
                    position="bottom-left"
                    className="w-full"
                />
            </div>

            {/* Campo Tipo de Cuidado */}
            <div>
                <label className="block text-gray-600 font-medium mb-1 flex items-center gap-2">
                    <Tag size={16} className="text-gray-500" />
                    Título/Tipo de Cuidado
                </label>
                <input
                    type="text"
                    name="tipo_cuidado"
                    value={formData.tipo_cuidado}
                    onChange={handleChange}
                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition"
                    placeholder="Ex: Curativo do Pé, Medição de Glicemia"
                />
            </div>

            {/* Campo Descrição */}
            <div>
                <label className="block text-gray-600 font-medium mb-1 flex items-center gap-2">
                    <FileText size={16} className="text-gray-500" />
                    Descrição/Instruções
                </label>
                <textarea
                    name="descricao"
                    value={formData.descricao}
                    onChange={handleChange}
                    rows="3"
                    placeholder="Descreva o agendamento ou instruções específicas..."
                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition"
                    required
                />
            </div>
            
            {/* Data e Hora Início */}
            <div>
                <label className="block text-gray-600 font-medium mb-1 flex items-center gap-2">
                    <Clock size={16} className="text-gray-500" />
                    Data e Hora de Início
                </label>
                <input
                    type="datetime-local"
                    name="data_hora_inicio"
                    value={formData.data_hora_inicio}
                    onChange={handleChange}
                    required
                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition"
                />
            </div>
            
            {/* Data e Hora Fim (Opcional) */}
            <div>
                <label className="block text-gray-600 font-medium mb-1 flex items-center gap-2">
                    <Clock size={16} className="text-gray-500" />
                    Data e Hora de Fim (Opcional)
                </label>
                <input
                    type="datetime-local"
                    name="data_hora_fim"
                    value={formData.data_hora_fim}
                    onChange={handleChange}
                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 transition"
                />
            </div>

            {/* Status (Permitido alterar apenas no modo de edição) - Usando DropdownMenu */}
            {initialData.id && (
                <div>
                    <label className="block text-gray-600 font-medium mb-1 flex items-center gap-2">
                        <CheckCircle size={16} className="text-gray-500" />
                        Status
                    </label>
                    <DropdownMenu
                        trigger={
                            <button
                                type="button"
                                onClick={(e) => e.preventDefault()}
                                className="w-full flex items-center justify-between gap-2 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400 hover:bg-gray-50 transition"
                            >
                                <div className="flex items-center gap-2">
                                    {(() => {
                                        const statusSelecionado = STATUS_AGENDAMENTO.find(s => s.value === formData.status);
                                        const Icon = statusSelecionado?.icon || CheckCircle;
                                        return (
                                            <>
                                                <Icon size={16} className="text-gray-500" />
                                                <span className="text-gray-700">
                                                    {statusSelecionado?.label || "Selecione o status"}
                                                </span>
                                            </>
                                        );
                                    })()}
                                </div>
                                <ChevronDown size={16} className="text-gray-400" />
                            </button>
                        }
                        items={STATUS_AGENDAMENTO.map(s => ({
                            id: s.value,
                            label: s.label,
                            icon: s.icon,
                            iconColor: 'text-gray-600',
                            onClick: () => handleDropdownChange('status', s.value)
                        }))}
                        position="bottom-left"
                        className="w-full"
                    />
                </div>
            )}

            {/* Botão de Submissão usando PrimaryButton */}
            <div className="flex justify-end pt-4">
                <PrimaryButton 
                    type="submit"
                    variant="primary"
                    className="w-full justify-center"
                >
                    {initialData.id ? 'Atualizar Agendamento' : 'Criar Agendamento'}
                </PrimaryButton>
            </div>
        </form>
    );
};

export default AgendamentoForm;
